module.exports = __webpack_public_path__ + "static/Spectre-dcc918f4d4cbe9a00363d3da888828a6.jpg";